var React = require('react');

function ArrowDown (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M14.8545 10.6045C15.1474 10.3117 15.1474 9.83678 14.8545 9.54389C14.5617 9.251 14.0868 9.251 13.7939 9.54389L10.5742 12.7636L10.5742 4.07422C10.5742 3.66 10.2384 3.32422 9.82422 3.32422C9.41001 3.32422 9.07422 3.66 9.07422 4.07422L9.07422 12.7636L5.85455 9.54389C5.56165 9.251 5.08678 9.251 4.79389 9.54389C4.50099 9.83678 4.50099 10.3117 4.79389 10.6045L9.29389 15.1045C9.3658 15.1765 9.44867 15.2307 9.53713 15.2673C9.62556 15.304 9.72253 15.3242 9.82422 15.3242C9.92672 15.3242 10.0244 15.3037 10.1134 15.2664C10.1977 15.2312 10.2769 15.18 10.3463 15.1127C10.3494 15.1097 10.3524 15.1067 10.3554 15.1037L14.8545 10.6045Z","fill":"#0D0D0D"}));
}

ArrowDown.defaultProps = {"width":"19","height":"19","viewBox":"0 0 19 19","fill":"none"};

module.exports = ArrowDown;

ArrowDown.default = ArrowDown;
